var _defs, _g, _rect, _rect2, _polygon, _rect3, _polygon2, _rect4, _polygon3, _rect5, _polygon4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiHealthStackedLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 159.35 81.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#006e8d;}.c{fill:#fff;}.d{fill:#9bcb4e;}.e{fill:#939598;}.f{fill:#afd248;}.g{fill:#cadd69;}.h{fill:#3fb981;}.i{fill:#5ebd75;}.j{fill:#79c364;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 127.39,
    cy: 39.4,
    r: 31.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M159.35,39.41c0-17.54-14.22-31.76-31.76-31.76s-31.76,14.22-31.76,31.76,14.22,31.76,31.76,31.76,31.76-14.22,31.76-31.76m-37.93,2.85c0,2.89-.31,4.29-1.13,5.7-1.37,2.28-5.03,3.17-8.22,3.17s-6.86-.88-8.23-3.17c-.82-1.4-1.13-2.8-1.13-5.7v-12.25h6.22v12.37c0,1.4,.18,2.32,.7,2.93,.49,.58,1.28,.85,2.44,.85s1.95-.27,2.44-.85c.52-.61,.7-1.53,.7-2.93v-12.37h6.22v12.25Zm9.99,8.47h-6.21V30.02h6.21v20.72Zm22.33-15.54l-5.39,2.59c-.52-2.01-1.65-3.2-3.6-3.2-2.65,0-3.99,2.19-3.99,5.78s1.34,5.7,3.99,5.7c1.83,0,2.89-.97,3.47-2.59l5.64,2.01c-1.46,3.32-4.42,5.61-9.14,5.61-6.55,0-10.3-4.39-10.3-10.73s3.96-10.72,10.42-10.72c4.94,0,7.86,2.83,8.89,5.54"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 79.19,
    width: 0.91,
    height: 81.84
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "f",
    y: 32.18,
    width: 30.65,
    height: 6.19
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "24.6 8.01 24.6 23.12 0 23.12 0 29.31 30.65 29.31 30.65 8.01 24.6 8.01"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 24.17,
    y: 40.81,
    width: 6.19,
    height: 30.65
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "0 40.81 0 46.85 15.1 46.85 15.1 71.46 21.29 71.46 21.29 40.81 0 40.81"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 32.94,
    y: 7.87,
    width: 6.19,
    height: 30.65
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "48.2 32.47 48.2 7.87 42.01 7.87 42.01 38.51 63.3 38.51 63.3 32.47 48.2 32.47"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 32.65,
    y: 40.95,
    width: 30.65,
    height: 6.19
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "63.3 50.02 32.65 50.02 32.65 71.31 38.69 71.31 38.69 56.21 63.3 56.21 63.3 50.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiHealthStackedLogo);
export default __webpack_public_path__ + "static/media/UI_Health_stacked_logo.e0520a70b5721558978aec03b8913573.svg";
export { ForwardRef as ReactComponent };